import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function DotNetDevelopment() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/wordpressdev.jpg)` }}>
        </div>


        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>.NET Development</h1>
            <p style={{ marginBottom: '3.5rem' }}>.Net is a widely used, open-source, cross-platform framework first introduced in the early 2000s. Since its inception, it has gone through several iterations and has emerged as one of the most versatile frameworks for the creation of powerful, functional, and dynamic web applications and websites. Its simplicity, security, and scalability have made it the framework of choice for developers working on everything from simple websites to highly complex web-based solutions.</p>
            <h3>.NET Provides Versatile Applications Serving a Wide Variety of Industries.</h3>
            <p style={{ marginBottom: '3.5rem' }}>Whatever your business' needs, there is a .NET application to fill it, and our talented developers are the right team help you best leverage these functional web solutions.</p>
            <ul style={{ listStyleType: 'square' }}>
              <li>Net Web App</li>
              <li>.Net Mobile App</li>
              <li>.Net Desktop App</li>
              <li>eCommerce Web Apps</li>
              <li>CMS Solutions</li>
              <li>ERP Solutions</li>
              <li>Our .NET Development Services</li>
            </ul>
            <p style={{ marginBottom: '3.5rem' }}>From starts-ups to large corporate enterprises, our team specializes in creating masterful web applications using the .NET framework.</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/fa4331fcb561b059b9e7b9c904149c3866aa9723-504x402.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default DotNetDevelopment